<h2 mat-dialog-title>
  <mat-icon class="title-icon">content_copy</mat-icon>
  {{ 'WORKCLASSIFICATION.TEMPLATES.COPYFROM.TITLE' | translate }}
</h2>
<mat-dialog-content class="dialog-container">
  <div class="app-container">
    <mat-form-field appearance="fill">
      <mat-label>{{ 'WORKCLASSIFICATION.TEMPLATES.COPYFROM.SOURCE' | translate }}</mat-label>
      <mat-icon matPrefix>content_copy</mat-icon>
      <mat-select [value]="sourceId()" (selectionChange)="selectSource($event.value)">
        @for (project of projects$ | async; track project.id) {
          <mat-option [value]="project.id">{{ project.costCenterNumber }} - {{ project.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    @if (previewLoading()) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    } @else if (previewLoaded() && previewNodes().length === 0) {
      <p class="text-faint">{{ 'WORKCLASSIFICATION.TEMPLATES.ERROR.SOURCE_TREE_EMPTY' | translate }}</p>
    } @else if (previewNodes().length > 0) {
      <app-classification-preview [nodes]="previewNodes()"></app-classification-preview>
    }

    <p class="info-note">
      <mat-icon class="info-icon">info</mat-icon>
      {{ 'WORKCLASSIFICATION.TEMPLATES.COPYFROM.INFO' | translate }}
    </p>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button class="btn-secondary" mat-dialog-close>{{ 'COMMON.CANCEL' | translate }}</button>
  <button mat-raised-button class="btn-primary" (click)="copy()" [disabled]="!canCopy">
    {{ 'WORKCLASSIFICATION.TEMPLATES.COPYFROM.CONFIRM' | translate }}
  </button>
</mat-dialog-actions>
